/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GiftCardInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GiftCardInfoQuery = {
  readonly giftCardBalance:
    | {
        readonly __typename: 'GiftCardBalance';
        readonly customerId: string;
        readonly giftCardBalance: number;
      }
    | { readonly __typename: 'UnableToGetGiftCardBalanceError'; readonly errorMessage: string };
};

export const GiftCardInfoDocument = gql`
  query GiftCardInfo {
    giftCardBalance {
      __typename
      ... on GiftCardBalance {
        customerId
        giftCardBalance
      }
      ... on UnableToGetGiftCardBalanceError {
        errorMessage
      }
    }
  }
`;

export function useGiftCardInfoQuery(
  options?: Omit<Urql.UseQueryArgs<GiftCardInfoQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GiftCardInfoQuery, GiftCardInfoQueryVariables>({
    query: GiftCardInfoDocument,
    ...options,
  });
}
